import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import Colors from 'js/constants/colors';

const MapViewButton = (props) => (
    <Button
        variant="outlined"
        color="pale"
        startIcon={<MapIcon/>}
        fullWidth
        size="medium"
        sx={{
            height: '40px',
            backgroundColor: Colors.BLACK_54_OPAQUE,
            '&.Mui-disabled': {
                pointerEvents: 'all',
                cursor: 'default',
            }
        }}
        onClick={props.onClick}
    >
        Map View
    </Button>
);

MapViewButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default MapViewButton;